import React from "react"
import { Link, useNavigate } from "react-router-dom"
import Text from "@src/components/ui/Text"
import Button from "./Button"

interface Action {
  label: string
  to?: string
  onClick?: () => void
}

interface ErrorPageProps {
  code: number | string
  title: string
  description?: string
  primary?: Action
  secondary?: Action
}

const ErrorPage: React.FC<ErrorPageProps> = ({ code, title, description, primary, secondary }) => {
  const navigate = useNavigate()

  const handlePrimary = (e: React.MouseEvent) => {
    if (primary?.onClick) return primary.onClick()
    if (primary?.to) return navigate(primary.to)
  }

  const handleSecondary = (e: React.MouseEvent) => {
    if (secondary?.onClick) return secondary.onClick()
    if (secondary?.to) return navigate(secondary.to)
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="max-w-3xl w-full card flex flex-col md:flex-row items-center gap-8 p-8 md:p-12">
        <div className="flex-1">
          <div className="text-6xl md:text-8xl font-extrabold text-legacy-blue dark:text-legacy-cream">
            {code}
          </div>
        </div>

        <div className="flex-1">
          <Text as="h2" className="mb-4" color="legacy-dark">
            {title}
          </Text>
          {description && (
            <Text as="p" className="mb-6 text-sm text-legacy-light">
              {description}
            </Text>
          )}

          <div className="flex gap-3 mt-4">
            {primary && <Button onClick={handlePrimary}>{primary.label}</Button>}

            {secondary && (
              <Button onClick={handleSecondary} variant="ghost">
                {secondary.label}
              </Button>
            )}

            {!primary && !secondary && (
              <>
                <Link to="/dashboard" className="btn-primary">
                  Ir al inicio
                </Link>
                <button onClick={() => navigate(-1)} className="btn-secondary">
                  Volver
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ErrorPage
